<template>
	<JBox>
		<CFormInput
			componentName="JSelect"
			name="options"
			:value="value"
			v-on="{ ...$listeners, focus: e => fetchOptions() }"
			:options="options"
		/>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { query } from "../api/queries"

export default {
	props: {
		value: String
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		async fetchOptions() {
			const res = await api({ query: query.tenantSettings, variables: null })
			this.options = res?.data?.tenantSettings?.hosts?.map(host => ({ name: host, value: host }))
		}
	},

	mounted() {
		this.fetchOptions()
	}
}
</script>
